// MyEnquiries.jsx — user enquiries from /api/enquiry/my
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { MyContext } from '../../../../Context/MyContext';
import API, { BASE_URL } from '../../../../Api/api';
import './MyEnquiries.css';
import AppIcon from '../../../../Components/AppIcon';

const STATUS = {
  pending: { label: 'Pending', color: '#f59e0b', bg: '#FEF3C7' },
  replied: { label: 'Replied', color: '#2563eb', bg: '#DBEAFE' },
  closed:  { label: 'Closed',  color: '#6b7280', bg: '#F3F4F6' },
};

const fmtDate = (d) => {
  if (!d) return '—';
  return new Date(d).toLocaleString('en-IN', {
    day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
};

const imgUrl = (path) => {
  if (!path) return null;
  if (path.startsWith('http')) return path;
  return `${BASE_URL}/${String(path).replace(/^\/+/, '')}`;
};

const MyEnquiries = ({ setActiveView }) => {
  const { user } = useContext(MyContext);
  const navigate = useNavigate();
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.id) return;
    setLoading(true);
    API.get('/enquiry/my')
      .then((r) => setEnquiries(Array.isArray(r.data) ? r.data : []))
      .catch(() => setEnquiries([]))
      .finally(() => setLoading(false));
  }, [user?.id]);

  return (
    <div className="menq-page">
      <div className="menq-topbar">
        <button type="button" className="menq-back" onClick={() => setActiveView('content')}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="16" height="16">
            <polyline points="15 18 9 12 15 6"/>
          </svg>
          Back
        </button>
        <div>
          <h2 className="menq-title">My Enquiries</h2>
          <p className="menq-sub">All property enquiries you have submitted</p>
        </div>
      </div>

      {loading ? (
        <div className="menq-loading">Loading enquiries…</div>
      ) : enquiries.length === 0 ? (
        <div className="menq-empty">
          <div className="menq-empty__icon">
            <AppIcon name="enquiry" size={40} />
          </div>
          <h3>No enquiries yet</h3>
          <p>When you enquire about a property, it will appear here.</p>
          <button type="button" className="menq-browse-btn" onClick={() => navigate('/properties')}>
            Browse Properties
          </button>
        </div>
      ) : (
        <div className="menq-list">
          {enquiries.map((item) => {
            const st = STATUS[item.status] || STATUS.pending;
            return (
              <article key={item.id} className="menq-card">
                <div className="menq-card__media">
                  {item.property_thumbnail ? (
                    <img src={imgUrl(item.property_thumbnail)} alt="" />
                  ) : (
                    <div className="menq-card__placeholder">
                      <AppIcon name="home" size={28} />
                    </div>
                  )}
                </div>
                <div className="menq-card__body">
                  <div className="menq-card__head">
                    <h3>{item.property_title || (item.property_id ? `Property #${item.property_id}` : 'General enquiry')}</h3>
                    <span className="menq-status" style={{ color: st.color, background: st.bg }}>{st.label}</span>
                  </div>
                  {item.message && <p className="menq-message">{item.message}</p>}
                  <div className="menq-meta">
                    <span>{fmtDate(item.createdAt)}</span>
                    {item.phone && <span>{item.phone}</span>}
                  </div>
                  {item.property_id && (
                    <button
                      type="button"
                      className="menq-view-btn"
                      onClick={() => navigate(`/property/${item.property_id}`)}
                    >
                      View Property
                    </button>
                  )}
                </div>
              </article>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MyEnquiries;
